import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { MAX_UNREAD_NOTIFICATION_COUNT } from '../../Config/UIConstants';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { NotificationButtonIcon } from '../../images/images';
import { colors } from '../../styles/colors';
import { styles } from './NavigatorStyles';

interface IProps {
    onClick(): void;
    store?: ApplicationStore;
}

@inject('store')
@observer
export class NotificationsButton extends React.Component<IProps> {
    public render() {
        const store = this.props.store!.notificationStore;
        if (!store) {
            return null;
        }
        const notificationsCount = Math.min(store.unreadNotificationsCount, MAX_UNREAD_NOTIFICATION_COUNT);
        return (
            <div style={bellContainerStyle}>
                <img
                    src={NotificationButtonIcon}
                    style={styles.navButtonIcon}
                    onClick={() => {
                        store.viewNotifications();
                        this.props.onClick();
                    }}
                />
                {store.unreadNotificationsCount > 0 && (
                    <div style={notificationsBubbleStyle}>
                        <p style={bubbleTextStyle}>{notificationsCount}</p>
                    </div>
                )}
            </div>
        );
    }
}

const notificationsBubbleStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: colors.LIGHT_BLUE,
    width: 22,
    height: 22,
    borderRadius: 11,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
};

const bubbleTextStyle: React.CSSProperties = { fontWeight: 800, color: colors.WHITE, textAlign: 'center', lineHeight: 21, fontSize: 12 };

const bellContainerStyle: React.CSSProperties = { position: 'relative', padding: 10, cursor: 'pointer' };



// WEBPACK FOOTER //
// ./src/SharedComponents/MainPageWithNavigator/NotificationsButton.tsx